/**
 * Content-free product telemetry via the shared Wolfe loader
 * (https://e.wolfe.works/static/w.js, loaded in index.html).
 *
 * Props are enumerated values only: never pass user text, file names, or lengths
 * that are not bucketed. The loader may be absent (blocked, offline, tests), so
 * capture never throws.
 */

type TelemetryProperties = Record<string, boolean | number | string>;

interface WolfeTelemetry {
  capture: (event: string, props?: TelemetryProperties) => void;
}

declare global {
   
  var wolfeTelemetry: WolfeTelemetry | undefined;
}

export const capture = (event: string, props?: TelemetryProperties): void => {
  try {
    globalThis.wolfeTelemetry?.capture(event, props);
  } catch {
    // Telemetry must never break the app.
  }
};

/** Coarse size bucket so event props never carry exact input lengths. */
export const sizeBucket = (length: number): string => {
  if (length === 0) {
    return 'empty';
  }
  if (length <= 100) {
    return 'xs';
  }
  if (length <= 1000) {
    return 'sm';
  }
  return 'lg';
};
